



























import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {translate} from "@/services/translation/translation";
import {getHtmlUnit} from "@/services/unit/unit";
import './_number-slider-dynamic-images.less';
import $ from 'jquery';
import {goToTop} from "@/services/position/position";
import {string} from "prop-types";
import vueSlider from 'vue-slider-component'

@Component({
    components: {
        vueSlider,
    }
})

export default class numberSliderDynamicImages extends Vue {
    @Prop() model;

    private data: any = {
        model: null,
        options: {
            min: 0,
            max: 100000000000000
        }
    };

    mounted() {
        goToTop('', this.model.componentSetting.id);
        this.data.model = typeof this.model.componentSetting.default == "string" ? parseInt(this.model.componentSetting.default) : 0;
        this.data.options.min = typeof this.model.componentSetting.min == "string" ? parseInt(this.model.componentSetting.min) : 0;
        this.data.options.max = typeof this.model.componentSetting.max == "string" ? parseInt(this.model.componentSetting.max) : 0;

        var pictureIndex = this.calcThisknessImageIndex(this.data.model);
        this.changeThisknessImage(pictureIndex);

    }


    @Watch("model", {immediate: true, deep: true})
    changeModel(newVal, oldVal){
        if(this.data.model != null && (this.model.value_id == "" || this.model.value == "" ) ){
            this.changeComponentSettingModel(this.data.model);
        }
    }


    @Watch('data.model')
    changeValue(newValue) {
        var pictureIndex = this.calcThisknessImageIndex(newValue);
        this.changeThisknessImage(pictureIndex);
        this.changeComponentSettingModel(newValue);

    }

    changeThisknessImage(index) {
        $.each($('.thicknessPicture'), function (i, e) {
            if($(e).attr('id') == 'thicknessPicture_'+index){
                $(e).removeClass('d-none');
            }else{
                $(e).addClass('d-none');

            }
        })

    }

    calcThisknessImageIndex(thickness) {
        thickness = parseInt(thickness);
        var min = this.data.options.min;
        var max = this.data.options.max;
        var maxInterval = max - min;
        var interval = maxInterval / 14;

        let pictureIndex :number = Math.round((thickness - min) / interval);

        return pictureIndex;
    }

    trans(key) {
        return translate(key);
    }

    getUnitView(unit){
        return getHtmlUnit(unit);
    }


    // @Watch("data.model", {immediate: true, deep: true})
    changeComponentSettingModel(newValue) {
        let componentValue :any = {};
        componentValue.id = this.model.componentSetting.id;
        componentValue.name = this.model.componentSetting.name;
        componentValue.value = newValue;
        componentValue.value_id = this.model.componentSetting.id;
        componentValue.next_question = this.model.componentSetting.next_question;
        componentValue.isEnableNext = this.model.isEnableNext;
        this.onSelectedQuestionValue(componentValue);

    }


    @Emit("selectedQuestionValue")
    onSelectedQuestionValue(value) {
    }

}

